import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import Tooltip from 'primevue/tooltip';
import { useAuthStore } from './stores/auth'

// PrimeVue
import PrimeVue from 'primevue/config';
import ToastService from 'primevue/toastservice';
import ConfirmationService from 'primevue/confirmationservice';

// PrimeVue Styles
import 'primevue/resources/themes/lara-light-teal/theme.css';
import 'primevue/resources/primevue.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';

// Eigene globale Styles
import './styles/base.css';
import '@/assets/styles/global.scss';

// Sicherstellen, dass auf mobilen Geräten die volle Breite genutzt wird
(function ensureViewportMeta() {
    if (typeof document === 'undefined') return;
    const desired = 'width=device-width, initial-scale=1, viewport-fit=cover';
    let meta = document.querySelector('meta[name="viewport"]');
    if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('name', 'viewport');
        document.head.prepend(meta);
    }
    const current = (meta.getAttribute('content') || '').trim();
    if (current !== desired) {
        meta.setAttribute('content', desired);
    }
})();

const app = createApp(App);
const pinia = createPinia();

app.use(pinia);
app.use(router);
// Deutsche Locale global setzen
app.use(PrimeVue, {
    ripple: true,
    locale: {
        firstDayOfWeek: 1,
        dayNames: ['Sonntag','Montag','Dienstag','Mittwoch','Donnerstag','Freitag','Samstag'],
        dayNamesShort: ['So','Mo','Di','Mi','Do','Fr','Sa'],
        dayNamesMin: ['So','Mo','Di','Mi','Do','Fr','Sa'],
        monthNames: ['Januar','Februar','März','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember'],
        monthNamesShort: ['Jan','Feb','Mär','Apr','Mai','Jun','Jul','Aug','Sep','Okt','Nov','Dez'],
        today: 'Heute',
        clear: 'Löschen',
        dateFormat: 'dd.mm.yy'
    }
});
app.use(ToastService);
app.use(ConfirmationService);
app.directive('tooltip', Tooltip);

// Nach Pinia Setup - Auth Store initialisieren
const authStore = useAuthStore()
authStore.checkAuth()

// PrimeVue Komponenten global registrieren
import Button from 'primevue/button';
import InputText from 'primevue/inputtext';
import Toast from 'primevue/toast';
import ConfirmDialog from 'primevue/confirmdialog';
import Calendar from 'primevue/calendar';

app.component('PrimeButton', Button);
app.component('InputText', InputText);
app.component('PrimeToast', Toast);
app.component('ConfirmDialog', ConfirmDialog);
app.component('Calendar', Calendar);

// Global directive for auto-focus
app.directive('focus', {
    mounted(el) {
        el.focus();
    }
});

// Global error handler
app.config.errorHandler = (err, vm, info) => {
    console.error('Fehler in Komponente:', vm);
    console.error('Info:', info);
    console.error('Fehler:', err);
};

app.mount('#app');
